import React from "react";
import {
  Bar,
  DownloadWrapper,
  IconsWrapper,
  Logo,
  LogoWrapper,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { DownloadOutlined, MessageOutlined, SearchOutlined } from "@assets";

const Appbar = () => {
  const navigate = useNavigate();

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  };

  const goToMessages = () => {
    navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
  };

  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  };

  return (
    <Bar>
      <DownloadWrapper>
        <DownloadOutlined onClick={goToDownload} />
      </DownloadWrapper>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <IconsWrapper>
        <MessageOutlined onClick={goToMessages} />
        <SearchOutlined onClick={goToSearch} />
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
